module.exports = __webpack_public_path__ + "static/media/page3.51699073.png";